import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import { useStartAPetitionPageState } from 'src/app/pages/startAPetitionV2/pageContext';

export function useBannerActions() {
	const { actions } = useStartAPetitionPageState();
	const track = useTracking();

	const edit = useCallback(
		(placement: 'top' | 'bottom') => {
			void track('sap_optional_preview_edit_click', { placement, context: 'optional-preview' });
			actions.send({ type: 'submit', target: 'create' });
		},
		[actions, track],
	);

	return { actions: { edit } };
}
